import {
  IconWrapper,
  IStyles,
  PrimaryButton,
  pxToRem,
  pxTovW,
  TextEditor,
} from '@geneo2-web/shared-ui';
import {
  Box,
  Button,
  Modal,
  Slide,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useState } from 'react';

const styles: IStyles = {
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // height: '100vh',
    width: '100vw',
    // marginY: { xs: pxToRem(10), md: pxTovW(25) },
    marginTop: { xs: pxToRem(50), md: pxTovW(200) },
    boxSizing: 'border-box',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    gap: { xs: pxToRem(40), md: pxTovW(20) },
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'center', md: 'flex-start' },
    width: { xs: '95%', md: '40%' },
  },
  contentBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(15), md: pxTovW(20) },
    backgroundColor: 'white',
    width: { xs: '95%', md: '100%' },
    borderRadius: { xs: pxToRem(10), md: pxTovW(20) },
    paddingX: { xs: pxToRem(10), md: pxTovW(15) },
    paddingY: { xs: pxToRem(10), md: pxTovW(15) },
    // minHeight: { xs: '50vh', md: '50vh' },
    maxHeight: { xs: '85vh', md: '70vh' },
    overflowY: 'auto',
  },
};

interface IProps {
  open: boolean;
  handleClose: () => void;
  instructions: string;
  onChange: (e: string | undefined) => void;
  addInstructionHandler: () => void;
}
export const InstructionPopup = (props: IProps) => {
  const { open, handleClose, instructions, onChange, addInstructionHandler } =
    props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const popupCloseHandler = () => {
    handleClose();
  };

  return (
    <Modal open={open} onClose={popupCloseHandler}>
      <Slide direction="up" in={open} mountOnEnter unmountOnExit timeout={500}>
        <Box sx={styles.root}>
          <Box sx={styles.container}>
            <Box sx={styles.contentBox}>
              <Typography variant="h2">Instructions:</Typography>
              <TextEditor
                value={instructions}
                onChange={onChange}
                rootStyles={{ padding: '0px' }}
                reactQuillStyles={{
                  height: isMobile ? '50vh' : pxTovW(350),
                  marginTop: isMobile ? pxToRem(10) : pxTovW(15),
                }}
              />
              <PrimaryButton
                onClick={addInstructionHandler}
                sx={{
                  paddingY: '0px',
                  paddingX: { xs: pxToRem(10), md: pxTovW(20) },
                  width: 'max-content',
                  margin: 'auto',
                }}
              >
                <Typography variant="h3" fontWeight="bold" color="common.white">
                  ADD INSTRUCTION
                </Typography>
              </PrimaryButton>
            </Box>

            <Button onClick={popupCloseHandler} sx={{ p: '0px' }}>
              <IconWrapper
                name="close-yellow"
                size="md"
                parentFolder="icons"
                type="png"
                customSx={{
                  width: { xs: pxToRem(33), md: pxTovW(54) },
                  height: { xs: pxToRem(33), md: pxTovW(54) },
                }}
              />
            </Button>
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};
